/* eslint-disable @typescript-eslint/strict-boolean-expressions */
import React, { useEffect, useRef, useState } from 'react'
import { Col, Row, Form, Button, Select, Card, Tooltip, Spin } from 'antd'
import { connect, useDispatch } from 'react-redux'
import commonStyles from '../../../Utils/Common.less'
import { CloudDownloadOutlined } from '@ant-design/icons'
import { GetCategoryDropDownList } from '../../../Services/GroupAndPartners'
import {
    GetRegisteClientDetails,
    GetServiceDropDownList,
} from '../../../Services/Common'
import {
    type ClientReportsData,
    type clientStatusReportInterface,
} from '../../../Types/Reports'
import { GetclientstatusReportData } from '../../../Services/Reports'
import hederimage from '../../../Assest/Svg/pattern-2.svg'
import jsPDF from 'jspdf'
import 'jspdf-autotable'
import { ErrorMessage } from '../../../Utils/Notification'

const ClientStatusReport = (
    props: clientStatusReportInterface
): React.ReactElement => {
    const { categoryDropDownList, regiterClientDetails, isLoading } = props

    const [form] = Form.useForm()
    const dispatch = useDispatch()
    const [noRecordsFound, setNoRecordsFound] = useState(false)
    const [selectedSatusId, setSelectedStatusId] = useState(1)
    const [selectedCompanyGroupId, setSelectedCompanyGroupsId] = useState(0)
    const [selectedBusinessId, setSelectedBusinessId] = useState(0)
    const hasFetchedOnce = useRef(false)
    useEffect(() => {
        if (!hasFetchedOnce.current) {
            hasFetchedOnce.current = true
            return
        }
        GetCategoryDropDownList(dispatch)
        GetRegisteClientDetails(dispatch)
        GetServiceDropDownList(dispatch)
    }, [dispatch])

    const handleSelectChangeStatus = (value: number): void => {
        setSelectedStatusId(value)
    }

    const handleSelectChangeCompanyGroup = (value: number): void => {
        setSelectedCompanyGroupsId(value)
    }

    const handleSelectChangeBusinesType = (value: number): void => {
        setSelectedBusinessId(value)
    }

    const getCompanyGroupLabel = (id: number): string => {
        if (id === 0) return 'All'
        const group = categoryDropDownList.find((item) => item.value === id)
        return group != null ? group.label : id.toString()
    }

    const getTabledata = async (): Promise<void> => {
        try {
            await form.validateFields()
            if (
                selectedBusinessId !== undefined &&
                selectedCompanyGroupId !== undefined &&
                selectedSatusId !== undefined
            ) {
                const reportData: ClientReportsData =
                    await GetclientstatusReportData(
                        dispatch,
                        selectedCompanyGroupId,
                        selectedBusinessId,
                        selectedSatusId
                    )

                if (
                    reportData?.clientStatus !== null &&
                    reportData?.clientStatus !== undefined &&
                    reportData?.clientStatus.length > 0
                ) {
                    generatePDF(reportData)
                    setNoRecordsFound(false)
                } else {
                    setNoRecordsFound(true)
                }
            }
        } catch (error) {
            console.error('Error fetching report data:', error)
        }
    }

    const generatePDF = (data: any): void => {
        // eslint-disable-next-line new-cap
        const doc = new jsPDF()
        const missingCompanyCategoryLabel = getCompanyGroupLabel(
            selectedCompanyGroupId
        )
        const headerColor: [number, number, number] = [0, 51, 153]
        doc.setTextColor(headerColor[0], headerColor[1], headerColor[2])
        const headerFontSize = 18
        const subHeaderFontSize = 20
        const addressFontSize = 10
        const categoryFontSize = 12
        const img = new Image()
        img.src = hederimage

        img.onload = function () {
            const canvas = document.createElement('canvas')
            canvas.width = img.width
            canvas.height = img.height
            const ctx = canvas.getContext('2d')
            ctx?.drawImage(img, 0, 0, img.width, img.height)
            const dataUrl = canvas.toDataURL('image/png')
            const logo = data?.businessDocumentTemplate?.companyLogo
            const marginTop = 5
            const marginLeftRight = 10
            const imageWidth =
                doc.internal.pageSize.getWidth() - 2 * marginLeftRight

            doc.addImage(
                dataUrl,
                'PNG',
                marginLeftRight,
                marginTop,
                imageWidth,
                5
            )

            const logoWidth = 50
            const logoHeight = 10
            const logoXPosition =
                doc.internal.pageSize.getWidth() - logoWidth - 10
            const logoYPosition = marginTop + 10

            const addLogoToPdf = async (
                doc: jsPDF,
                logoUrl: string | URL | Request,
                logoXPosition: number,
                logoYPosition: number,
                logoWidth: number,
                logoHeight: number
            ): Promise<void> => {
                try {
                    // Fetch the logo as a base64 image
                    const response = await fetch(logoUrl)

                    if (!response.ok) {
                        ErrorMessage('Image Not Found')
                    }

                    const arrayBuffer = await response.arrayBuffer()
                    const base64Image = `data:image/png;base64,${btoa(
                        new Uint8Array(arrayBuffer).reduce(
                            (data, byte) => data + String.fromCharCode(byte),
                            ''
                        )
                    )}`

                    // Add the image to the PDF
                    doc.addImage(
                        base64Image,
                        'PNG',
                        logoXPosition,
                        logoYPosition,
                        logoWidth,
                        logoHeight
                    )
                } catch (error) {
                    console.error('Error adding logo to PDF:', error)

                    // Add fallback text to indicate the image could not be loaded
                    doc.setFont('helvetica', 'bold')
                    doc.setFontSize(12)
                    doc.text(
                        'Image not found',
                        logoXPosition + logoWidth / 2, // Center the text horizontally
                        logoYPosition + logoHeight / 2, // Center the text vertically
                        { align: 'center' }
                    )
                }
            }

            if (logo) {
                void addLogoToPdf(
                    doc,
                    logo,

                    logoXPosition,
                    logoYPosition,
                    logoWidth,
                    logoHeight
                )
                // doc.addImage(
                //     logo,
                //     'PNG',
                //     logoXPosition,
                //     logoYPosition,
                //     logoWidth,
                //     logoHeight
                // )
            }

            const textXPosition = 14
            const textYPosition = logoYPosition + marginTop

            doc.setFontSize(headerFontSize)
            doc.setTextColor(0, 51, 153)
            doc.text(missingCompanyCategoryLabel, textXPosition, textYPosition)

            const addressYPosition = textYPosition + 5
            doc.setFontSize(addressFontSize)
            doc.setTextColor(160, 160, 160)
            doc.text(
                '14 Elm Road, Chessington, KT9 1AW, UNITED KINGDOM',
                textXPosition,
                addressYPosition
            )

            const subHeaderYPosition = addressYPosition + 10
            doc.setFontSize(subHeaderFontSize)
            doc.setTextColor(0, 51, 153)
            doc.text('Client Status Report', textXPosition, subHeaderYPosition)

            const lineStartX =
                textXPosition + doc.getTextWidth('Client Status Report') + 5
            const lineEndX = lineStartX + 80
            const lineY = subHeaderYPosition
            doc.setDrawColor(0, 51, 153)
            doc.setLineWidth(1)
            doc.line(lineStartX, lineY, lineEndX, lineY)

            doc.setFontSize(categoryFontSize)
            doc.setTextColor(0, 0, 0)
            const headers = [
                [
                    { content: 'Company Name', styles: { halign: 'left' } },
                    { content: 'Client Number', styles: { halign: 'left' } },
                    { content: 'Contact Name', styles: { halign: 'left' } },
                    { content: 'Contact Info', styles: { halign: 'left' } },
                ],
            ]
            const tabledata =
                // eslint-disable-next-line @typescript-eslint/strict-boolean-expressions
                data?.clientStatus?.map(
                    (item: {
                        clientName: any
                        clientNumber: any
                        contactName: any
                        contactNumber: any
                        emailAddress: any
                        alternativeEmailAddress: any
                    }) => [
                        item.clientName,
                        item.clientNumber,
                        item.contactName,
                        `${item.contactNumber}\n${item.emailAddress}\n${item.alternativeEmailAddress}`,
                    ]
                ) || []

            doc.autoTable({
                head: headers,
                body: tabledata,
                startY: 40,
                theme: 'grid',
                styles: {
                    cellPadding: 3,
                    fontSize: 8,
                    halign: 'left',
                    valign: 'middle',
                },
                headStyles: {
                    fillColor: [255, 255, 255],
                    textColor: [0, 0, 0],
                    lineColor: [160, 160, 160],
                    lineWidth: 0.05,
                },
                columnStyles: {
                    0: { cellWidth: 50 },
                    1: { cellWidth: 25 },
                    2: { cellWidth: 40 },
                    3: { cellWidth: 75 },
                },
            })

            const today = new Date()
            const formattedDate = `${
                today.getMonth() + 1
            }/${today?.getDate()}/${today.getFullYear()}`
            const totalPages = doc.getNumberOfPages()

            for (let i = 1; i <= totalPages; i++) {
                doc.setPage(i)
                doc.setFontSize(10)

                const footerText = `Printed on: ${formattedDate} ${i}/${totalPages} Total Count: ${tabledata?.length}`
                const textWidth = doc.getTextWidth(footerText)
                const pageWidth = doc.internal.pageSize.getWidth()
                const xPosition = (pageWidth - textWidth) / 2
                const yPosition = doc.internal.pageSize.getHeight() - 10

                doc.text(footerText, xPosition, yPosition)
            }

            doc.save('client_status_report.pdf')
        }
    }

    const StatustDropdowlist = [
        {
            value: 1,
            label: 'Active',
        },
        {
            value: 2,
            label: 'In-active',
        },
    ]

    return (
        <>
            <Card title="Client Status Reports" style={{ marginTop: '20px' }}>
                <Spin spinning={isLoading} size="large">
                    <div className={commonStyles.formWrapper}>
                        <Form
                            name="complex-form"
                            labelCol={{ span: 24 }}
                            wrapperCol={{ span: 24 }}
                            initialValues={{ remember: true }}
                            autoComplete="off"
                            form={form}
                        >
                            <Row gutter={16}>
                                <Col span={8}>
                                    <Form.Item label="Company Group">
                                        <Select
                                            placeholder="Please select"
                                            onChange={
                                                handleSelectChangeCompanyGroup
                                            }
                                            value={selectedCompanyGroupId}
                                            allowClear
                                            showSearch
                                            filterOption={(input, option) =>
                                                option?.label
                                                    ?.toLowerCase()
                                                    .includes(
                                                        input.toLowerCase()
                                                    ) ?? false
                                            }
                                            options={[
                                                { value: 0, label: 'All' },
                                                ...categoryDropDownList,
                                            ]}
                                        />
                                    </Form.Item>
                                </Col>
                                <Col span={8}>
                                    <Form.Item label="Business Type">
                                        <Select
                                            placeholder="Please select"
                                            onChange={
                                                handleSelectChangeBusinesType
                                            }
                                            value={selectedBusinessId}
                                            allowClear
                                            showSearch
                                            optionFilterProp="children"
                                            filterOption={(input, option) =>
                                                (option?.label ?? '')
                                                    .toLowerCase()
                                                    .includes(
                                                        input.toLowerCase()
                                                    )
                                            }
                                            options={[
                                                { value: 0, label: 'All' },
                                                ...regiterClientDetails,
                                            ]}
                                        />
                                    </Form.Item>
                                </Col>
                                <Col span={8}>
                                    <Form.Item label="Status">
                                        <Select
                                            placeholder="Please select"
                                            onChange={handleSelectChangeStatus}
                                            value={selectedSatusId}
                                            options={StatustDropdowlist}
                                            allowClear
                                            showSearch
                                            optionFilterProp="children"
                                            filterOption={(input, option) =>
                                                option?.label
                                                    ?.toLowerCase()
                                                    .includes(
                                                        input.toLowerCase()
                                                    ) ?? false
                                            }
                                        />
                                    </Form.Item>
                                </Col>
                            </Row>

                            <Row gutter={16}>
                                <Col offset={21} span={2}>
                                    <Tooltip title="Download Report">
                                        <Button
                                            type="primary"
                                            // eslint-disable-next-line @typescript-eslint/no-misused-promises
                                            onClick={getTabledata}
                                        >
                                            <CloudDownloadOutlined />
                                        </Button>
                                    </Tooltip>
                                </Col>
                            </Row>
                        </Form>
                    </div>{' '}
                    {noRecordsFound && (
                        <div style={{ textAlign: 'left', marginTop: '20px' }}>
                            <span
                                style={{
                                    color: '#808080',
                                    fontSize: '20px',
                                    fontWeight: 'bold',
                                }}
                            >
                                {' '}
                                No Records found
                            </span>
                        </div>
                    )}
                </Spin>
            </Card>
        </>
    )
}

const mapStateToProps = (state: any): clientStatusReportInterface => {
    return {
        categoryDropDownList: state.initial.categoryDropDownList,
        serviceDropDownList: state.initial.serviceDropDownList,
        regiterClientDetails: state.common.regiterClientDetails,
        clientstausList: state.reports.clientstausList,
        isLoading: state.common.isLoading,
    }
}

export default connect(mapStateToProps)(ClientStatusReport)
